module.exports = __webpack_public_path__ + "static/newsletter-oct-2019-60e44b52ec0686234e49b2c7d11bf90f.pdf";